<div class="container" [ngClass]="{'header__cms': !userIsAuthenticated }">
  <absg-spinner id="loginSpinner" [show]="isSpinnerVisible$ | async"></absg-spinner>
  <div class="row">
    <div class="col-10 flex header__content">
      <svg class="header__logo fill-white">
        <use xlink:href="./assets/icons/connect-icons.svg#Nucleus-TM"></use>
      </svg>
      @if (!userIsAuthenticated) {
        <button class="btn--white-aqua ml1" id="btnBack" (click)="reloadCMS()">Home <svg>
            <use xlink:href="./assets/icons/connect-icons.svg#Home"></use>
          </svg>
        </button>
      }
      @if (practiceDomain$ | async; as vm) {
        <div class="flex-auto align-center center">
          @if (vm.showPracticeDomain) {
            <div class="h6" id="divPracticeDomain">{{vm.practiceDomain}}</div>
          }
          <div class="h5" id="divPracticeNameAddress">{{vm.practiceDetails}}</div>
        </div>
      }
      <div class="right h6">
        <div class="bold" id="divUserName">{{userFullName$|async}}</div>
        <div id="divStationNameBuildEnv">{{hostName$ | async}} | v{{appVersion$ | async}}
          {{environmentName}} {{ ((retryCount$ | async) > 0) ? '(Offline... Reconnecting)': ''}}
        </div>
      </div>
    </div>
    @if (!userIsAuthenticated) {
      <div id="divLogIn" class="col-2 header__log-out">
        <button id="btnLogin" type="button" #btnLogin class="btn btn--core-blue width100 height100 border-radius-0"
          [ngClass]="{ 'is-disabled' : !(isLoginEnabled$ | async)}" [disabled]="!(isLoginEnabled$ | async)" (click)="logIn()"> Log In </button>
      </div>
    } @else {
      <div id="divLogOut" class="col-2 header__log-out" (click)="logOut()"> Log Out </div>
    }
  </div>
</div>